import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalAlertsDetailRoute: InvariantJiraRoute = {
	name: 'eoc-global-alert-detail',
	path: '/jira/ops/alerts/:id',
	exact: true,
};
